import { useStore } from 'hooks/useStore';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useDrugSearchBar = () => {
  const {
    FactsStore: {
      drugSearchInput,
      isAllDrugsLoading,
      isConceptsListLoading,
      filteredDrugMoleculesForSearch,
      handleFetchAllConceptDetailsForSearch,
      handleFilterDrugSearch,
      handleDrugSearchInputChange,
      handleSearch,
      isActivateSelected,
      toggleActivateSelected,
      isInctivateSelected,
      toggleInActiveSelected,
      handleEnterKeyDownDrugSearchField,
      fetchAllTargetMarketStrategyCodes,
    },
  } = useStore();
  const isSearchButtonDisabled = () => {
    return drugSearchInput ? false : true;
  };

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== '/facts/active_drug_strategy' && isConceptsListLoading) {
      navigate('/facts/active_drug_strategy');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- redirect when loading
  }, [drugSearchInput]);

  useEffect(() => {
    handleFetchAllConceptDetailsForSearch();
    fetchAllTargetMarketStrategyCodes();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run on mount
  }, []);

  return {
    drugSearchInput,
    isAllDrugsLoading,
    isConceptsListLoading,
    filteredDrugMoleculesForSearch,
    handleFilterDrugSearch,
    isSearchButtonDisabled,
    handleDrugSearchInputChange,
    handleSearch,
    isActivateSelected,
    toggleActivateSelected,
    isInctivateSelected,
    toggleInActiveSelected,
    handleEnterKeyDownDrugSearchField,
  };
};
